import React, { useRef } from "react";
import { Sidebar } from "./Sidebar";
import { useTheme } from "../theme/useTheme";
import { GeniePanelProvider } from "../context/GeniePanelContext";
import { Genie } from "../components/Genie";
import { ScrollToTop } from "../components/ScrollToTop";

export const Layout: React.FC<React.PropsWithChildren> = ({ children }) => {
  const { mode, loading } = useTheme();

  const mainRef = useRef<HTMLElement>(null);
  return (
    <GeniePanelProvider>
      <div
        className={`flex h-screen transition-colors duration-300 ${
          mode === "light" ? "bg-gray-50" : "bg-slate-900"
        }`}
      >
        <Sidebar />
        <main
          ref={mainRef}
          className={`flex-1 overflow-auto transition-colors duration-300 ${
            mode === "light"
              ? "bg-gray-50 text-gray-900"
              : "bg-slate-900 text-slate-100"
          }`}
          role="main"
        >
          {children}
        </main>
        <ScrollToTop scrollContainerRef={mainRef} />
        {/* Genie AI Assistant */}
        <Genie />
        {loading && (
          <div
            role="status"
            className="w-full h-full right-0 top-0 fixed bg-slate-900 z-[50] bg-opacity-80 flex justify-center"
          >
            <div className="loading-wave m-auto">
              <div className="loading-bar"></div>
              <div className="loading-bar"></div>
              <div className="loading-bar"></div>
              <div className="loading-bar"></div>
            </div>
          </div>
        )}
      </div>
    </GeniePanelProvider>
  );
};
